import LoggedUserModel from './Common/LoggedUserModel';
import ActiveChatModel from './ChatRoom/ActiveChatModel';
import ChatMessagesModel from './ChatRoom/chatMessagesModel'
import PublicChatsModel from './ChatRoom/PublicChatsModel';
import GroupChatsModel from './ChatRoom/GroupChatsModel';
import FriendChatsModel from './ChatRoom/FriendChatsModel';
import OnlineUsersModel from './ChatRoom/OnlineUsersModel';
import IgnoredUsersModel from './ChatRoom/IgnoredUsersModel';
import ChatroomConfigModel from './ChatRoom/ChatroomConfigModel';
import TitleBarModel from './Common/TitleBarModel';

export default function (options) {
    let Vuex = options.Vuex;

    return new Vuex.Store({
        state: {},
        mutations: {},
        actions: {},
        getters: {},
        modules: {
            loggedUserModel: LoggedUserModel,
            publicChatsModel: PublicChatsModel,
            groupChatsModel: GroupChatsModel,
            friendChatsModel: FriendChatsModel,
            activeChatModel: ActiveChatModel,
            chatMessagesModel: ChatMessagesModel,
            onlineUsersModel: OnlineUsersModel,
            ignoredUsersModel: IgnoredUsersModel,
			chatroomConfigModel: ChatroomConfigModel,
            titleBarModel: TitleBarModel,
        }
    });

}


// WEBPACK FOOTER //
// ./src/store.js